import { render, staticRenderFns } from "./DisabledItemButton.vue?vue&type=template&id=ab2af7fc&scoped=true"
import script from "./DisabledItemButton.vue?vue&type=script&lang=js"
export * from "./DisabledItemButton.vue?vue&type=script&lang=js"
import style0 from "./DisabledItemButton.vue?vue&type=style&index=0&id=ab2af7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2af7fc",
  null
  
)

export default component.exports